import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { assetsApi } from 'src/Services/API';
import { AssetDto, CreateAssetDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useCreateAsset = (options?: UseMutationOptions<AssetDto, unknown, CreateAssetDto>) => {
  const queryClient = useQueryClient();
  return useMutation<AssetDto, unknown, CreateAssetDto>(
    'create-asset',
    async data => {
      const response = await assetsApi.assetsControllerCreate(data);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data: AssetDto, variables: CreateAssetDto, context: unknown) => {
        trackEvent('Asset', 'create', data.name);
        queryClient.invalidateQueries({ queryKey: ['fetch-assets'] });
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
